var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import clsx from "clsx";
import React from "react";
import GridMenuLink from "./GridMenuLink";
import RoundIcon from "./RoundIcon";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./GridMenu.module.css";
export default function GridMenu(_a) {
  var _b = _a,
    {
      as: Component = "nav",
      className,
      components: {
        Link = GridMenuLink,
        Icon = RoundIcon
      } = {
        Link: GridMenuLink,
        Icon: RoundIcon
      },
      items,
      styles = defaultStyles
    } = _b,
    restProps = __objRest(_b, ["as", "className", "components", "items", "styles"]);
  let attributes = typeof Component === "string" ? filterAttributes(restProps) : restProps;
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    className: clsx(styles.component, className)
  }, attributes), /* @__PURE__ */React.createElement("ul", {
    className: clsx(styles.list)
  }, items.map((item, index) => {
    const _a2 = item,
      {
        icon,
        label,
        description
      } = _a2,
      itemProps = __objRest(_a2, ["icon", "label", "description"]);
    return /* @__PURE__ */React.createElement("li", {
      key: index,
      className: clsx(styles.item)
    }, /* @__PURE__ */React.createElement(Link, __spreadValues({
      className: clsx(styles.link)
    }, itemProps), icon && /* @__PURE__ */React.createElement(Icon, __spreadValues({
      className: clsx(styles.icon)
    }, item.icon)), /* @__PURE__ */React.createElement("div", {
      className: clsx(styles.text)
    }, /* @__PURE__ */React.createElement("p", {
      className: clsx(styles.title)
    }, label), description && /* @__PURE__ */React.createElement("p", {
      className: clsx(styles.description)
    }, description))));
  })));
}